import clsx from "clsx";
import type { ComponentProps } from "react";

import { Button } from "@shared/ui/button";
import { Body } from "@shared/ui/typography/body";

import s from "./slider-tabs.module.scss";

export type SimpleTabsItem = {
  id: string | number;
  label: string;
};

export type SimpleTabsProps = ComponentProps<"div"> & {
  items: SimpleTabsItem[];
  activeItemId: string | number;
  onTabClick: (id: string | number) => void;
  fullWidth?: boolean;
};

export const SimpleTabs = ({
  items,
  activeItemId,
  onTabClick,
  className,
  fullWidth = false,
}: SimpleTabsProps) => {
  return (
    <div className={clsx(s.root, { [s.fullWidth]: fullWidth }, className)}>
      {items.map((item) => (
        <Button
          key={item.id}
          className={clsx(s.tabButton, {
            [s.activeButton]: activeItemId === item.id,
          })}
          onClick={() => onTabClick(item.id)}
        >
          <Body size="uppercase" weight="semiBold">
            {item.label}
          </Body>
        </Button>
      ))}
    </div>
  );
};
